import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";

const PushToTenantDialog = ({ tenants, questionCount, onPush, onCancel }) => {
  const [selectedTenantId, setSelectedTenantId] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTenantId) {
      alert("Please select a tenant");
      return;
    }

    setLoading(true);
    try {
      await onPush(selectedTenantId, active);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Push Questions to Tenant</DialogTitle>
          <DialogDescription>
            Select a tenant database to push {questionCount} question
            {questionCount !== 1 ? "s" : ""} to.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="tenant">Select Tenant *</Label>
            <select
              id="tenant"
              value={selectedTenantId}
              onChange={(e) => setSelectedTenantId(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">-- Select a tenant --</option>
              {tenants.map((tenant) => (
                <option key={tenant._id} value={tenant._id}>
                  {tenant.accountName} ({tenant.name})
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="active"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <Label htmlFor="active" className="cursor-pointer">
              Create questions as active
            </Label>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700"
              disabled={loading || !selectedTenantId}
            >
              {loading ? "Pushing..." : "Push Questions"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PushToTenantDialog;

